import React from 'react';
import { UnLoggedLayout } from '@avila-tek/ui/src';
import { useSession } from 'next-auth/react';
import { useRouter } from 'next/router';
import { FadeAnimation, SignInForm } from '../../components';
import { roles, rolesTranslatePlural } from '../../static';
import meitBoxesImg from '../../public/images/meit-boxes.png';
import meitLogoImg from '../../public/logos/logo-white.png';

function SignInAlly() {
  const { status } = useSession();
  const router = useRouter();

  React.useEffect(() => {
    if (status === 'authenticated') {
      router.push('/app/dashboard');
    }
  }, [status]);

  if (status === 'loading') return null;

  return (
    <UnLoggedLayout
      userType={roles.ally}
      meitLogoImgSrc={meitLogoImg.src}
      meitBoxesImgSrc={meitBoxesImg.src}
      roleTranslated={rolesTranslatePlural[roles.ally]}
      bgClassName="bg-purple-300"
    >
      <FadeAnimation>
        <SignInForm userType={roles.ally} />
      </FadeAnimation>
    </UnLoggedLayout>
  );
}

SignInAlly.auth = false;

export default SignInAlly;
